export default __webpack_public_path__ + "static/media/F_Farol.19934d8b.svg";